<loading-overlay [isLoading]="isLoading > 0"></loading-overlay>

@if (isLoading === 0 && productionCardFormGroup.value) {
  <div (click)="selected.click(); $event.stopPropagation()">
    <p-panel
      class="block"
      [ngClass]="{
        'production-card-selected': (isSelected() || selectedCard) && isForSelection,
        production__card__selection: isForSelection,
      }"
    >
      <ng-template pTemplate="header">
        <h4>
          <a (click)="navigateToProductionCardDetails.emit(productionCardFormGroup.value.productionCardNumber!)">{{ productionCardFormGroup.value.productionCardNumber }}</a>
        </h4>
      </ng-template>

      <ng-template pTemplate="icons">
        <div class="actions flex items-center" [formGroup]="productionCardFormGroup">
          <p-button severity="secondary" icon="pi pi-print" (click)="getProductionCardReport()" />
          <p-select [options]="statusOptions()" formControlName="status" appendTo="body"></p-select>
        </div>
      </ng-template>

      <div class="col-sm">
        <p-panel header="Filter" data-tone="surface">
          <p-card data-variant="flat">
            <div class="col-sm">
              <div class="row-sm-start-center">
                <p class="text-sm">
                  {{ 'productionCard.tags' | translateWF: 'Tags' }}
                </p>
                <p-multiselect
                  *ngIf="showMultiselect"
                  id="tags"
                  [formControl]="tagsControl"
                  [options]="tags"
                  optionLabel="name"
                  [styleClass]="'w-full'"
                  [filter]="true"
                  placeholder="Select"
                  appendTo="body"
                  (onFilter)="onFilterTag($event)"
                >
                  <ng-template pTemplate="footer">
                    <div class="px-3 pb-2 flex flex-col gap-2">
                      <button *ngIf="canAddTag" type="button" pButton class="flex items-center justify-between w-full px-4 py-2" (click)="addNewTag()">
                        {{ 'productionCard.addTag' | translateWF: 'Add ' }}"{{ filteredTagText }}"
                        <i class="pi pi-plus ml-auto"></i>
                      </button>

                      <button *ngIf="(tagsControl.value?.length || 0) > 0" type="button" pButton class="flex items-center justify-between w-full px-4 py-2" (click)="saveTags()">
                        {{ 'productionCard.selectTags' | translateWF: 'Select Tags' }}
                        <i class="pi pi-check ml-auto"></i>
                      </button>
                    </div>
                  </ng-template>
                </p-multiselect>

                <div *ngIf="!showMultiselect" class="flex items-center gap-2 flex-wrap">
                  <div class="tags-container">
                    <ng-container>
                      <span *ngFor="let tag of tagsControl.value" class="tag">
                        {{ tag.name }}
                        <button type="button" class="remove-tag" (click)="removeTag(tag)">&times;</button>
                      </span>
                    </ng-container>
                    <i class="pi pi-plus" (click)="toggleMultiselect()" style="cursor: pointer" aria-label="Add tag" title="Add tag"></i>
                  </div>
                </div>
              </div>
              <div class="grid-auto-4">
                <div class="form-box">
                  <label for="">
                    {{ 'productionCard.color' | translateWF: 'Color' }}
                  </label>
                  @if (productionCardFormGroup.disabled && !productionCardFormGroup.controls.color.value) {
                    <input pInputText class="w-full" [value]="productionCardFormGroup.controls.colorName.value || '—'" [disabled]="true" />
                  } @else {
                    <p-select
                      fluid
                      class="w-full"
                      [placeholder]="'productionCard.selectColor' | translateWF: 'Select a color'"
                      optionLabel="name"
                      [options]="colors"
                      [formControl]="productionCardFormGroup.controls.color"
                    ></p-select>
                  }
                </div>
                <div class="form-box">
                  <label for="">
                    {{ 'productionCard.dyeingMachine' | translateWF: 'Dyeing Machine' }}
                  </label>
                  <p-select
                    fluid
                    class="w-full"
                    optionLabel="assetId"
                    [options]="assets"
                    [placeholder]="'productionCard.selectDyeingMachine' | translateWF: 'Select a Dyeing Machine'"
                    [formControl]="productionCardFormGroup.controls.dyeingAsset"
                  ></p-select>
                </div>
                @if (productionCardFormGroup.value.id) {
                  @if (!readonly) {
                    <div class="form-box" [ngClass]="{ '-mt-5': isForSelection }">
                      <label for="">
                        {{ 'productionCard.quantityToUse' | translateWF: 'Quantity to Use' }}
                      </label>
                      <input pInputText type="text" class="w-full" [value]="productionCardTotalQty | number: '1.2-2'" disabled />
                    </div>
                  }
                }
                @if (!productionCardFormGroup.value.id) {
                  <div class="form-box">
                    <label for="">
                      {{ 'productionCard.qtyToUseNewPC' | translateWF: 'Quantity to Use (NEW PC)' }}
                    </label>
                    <p-inputNumber [minFractionDigits]="2" [maxFractionDigits]="2" [formControl]="quantityToUseNewPC" class="w-full"></p-inputNumber>
                  </div>
                }
              </div>
            </div>
          </p-card>
        </p-panel>

        <p-card data-variant="compact">
          <p-table [value]="productionCardFormGroup.controls.productionCardEntries.controls" responsiveLayout="scroll" class="mb-[2rem] w-full" styleClass="w-full" size="small">
            <ng-template pTemplate="header">
              <tr class="dark__header">
                <th>
                  {{ 'productionCard.fabricCode' | translateWF: 'Fabric Code' }}
                </th>
                <th>
                  {{ 'productionCard.qty' | translateWF: 'Quantity' }}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-fabricControl>
              <tr>
                <td>({{ fabricControl.value.fabricCode }}) {{ getFabricByCode(fabricControl.value.fabricCode)?.longDescription }}</td>
                <td>{{ fabricControl.value.quantity | number: '1.2-2' }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="footer">
              <tr class="font-semibold border-t">
                <td>Total</td>
                <td>{{ productionCardTotalQty | number: '1.2-2' }}</td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      </div>

      <ng-template pTemplate="footer">
        <div class="date-information">
          @if (batchingEstimatedDate.value) {
            <p>
              {{ 'productionCard.startAt' | translateWF: 'Start at' }}
              <b>{{ batchingEstimatedDate.value | date: 'dd/MM/yyyy' }}</b>
            </p>
            <span class="status-pc"></span>
          }
          @if (finishingEstimatedDate.value) {
            <p>
              {{ 'productionCard.endAt' | translateWF: 'End at' }}
              <b>{{ finishingEstimatedDate.value | date: 'dd/MM/yyyy' }}</b>
            </p>
          }
          <div *ngIf="!isForSelection">
            <p-button
              [label]="'productionCard.saveProductionCard' | translateWF: 'Save Production Card'"
              icon="pi pi-save"
              severity="success"
              (onClick)="saveProductionCard()"
              [disabled]="!canSave() || isLoading > 0"
              size="small"
            />
          </div>
          <p-button icon="pi pi-ellipsis-h" (click)="popoverDates.toggle($event)" />
        </div>
      </ng-template>
      <!-- this important because with it the production card is selected -->
      <input type="checkbox" #selected [(ngModel)]="isSelected" (change)="onProductionCardSelected($event)" class="hidden" />
    </p-panel>
  </div>
}

<p-popover #popoverDates>
  <div class="grid-2" [formGroup]="formGroupDates">
    <!-- batching dates -->
    <div class="form-box">
      <label for="">
        {{ 'productionCard.batchingEstimatedDate' | translateWF: 'Batching Estimated Date' }}
      </label>
      <p-datepicker [iconDisplay]="'input'" [showIcon]="true" formControlName="batchingEstimatedDate" />
    </div>
    <div class="form-box">
      <label for="">
        {{ 'productionCard.batchingRealDate' | translateWF: 'Batching Real Date' }}
      </label>
      <p-datepicker [iconDisplay]="'input'" [showIcon]="true" [disabled]="true" />
    </div>
    <!-- dyeing dates -->
    <div class="form-box">
      <label for="">
        {{ 'productionCard.dyeingEstimatedDate' | translateWF: 'Dyeing Estimated Date' }}
      </label>
      <p-datepicker [iconDisplay]="'input'" [showIcon]="true" formControlName="dyeingEstimatedDate" />
    </div>
    <div class="form-box">
      <label for="">
        {{ 'productionCard.dyeingRealDate' | translateWF: 'Dyeing Real Date' }}
      </label>
      <p-datepicker [iconDisplay]="'input'" [showIcon]="true" [disabled]="true" />
    </div>
    <!-- finishing dates -->
    <div class="form-box">
      <label for="">
        {{ 'productionCard.finishingEstimatedDate' | translateWF: 'Finishing Estimated Date' }}
      </label>
      <p-datepicker [iconDisplay]="'input'" [showIcon]="true" formControlName="finishingEstimatedDate" />
    </div>
    <div class="form-box">
      <label for="">
        {{ 'productionCard.finishingRealDate' | translateWF: 'Finishing Real Date' }}
      </label>
      <p-datepicker [iconDisplay]="'input'" [showIcon]="true" [disabled]="true" />
    </div>
  </div>
</p-popover>
